export function getBookingsByStatus(bookings, bool) {
    return bookings.filter(booking => booking.status === bool)
}
